export default [
  {
    path: '/pay/broker/leaseDetail',
    name: 'leaseDetailBroker',
    meta: {
      title: '租约详情'
    },
    component: () => System.import('@/PagesAreaBroker/lease_new/leaseDetail')
  },
  {
    path: '/broker/cAContract',
    name: 'cAContractBroker',
    meta: {
      title: '电子合同'
    },
    component: () => System.import('@/PagesAreaBroker/CA/cAContract')
  },
  {
    path: '/broker/viewerContract',
    name: 'viewerContractBroker',
    meta: {
      title: '电子合同'
    },
    component: () => System.import('@/PagesAreaBroker/CA/viewerContract')
  },
  {
    path: '/pay/broker/bill',
    name: 'billBroker',
    meta: {
      title: '账单'
    },
    component: () => System.import('@/PagesAreaBroker/bill/bill')
  },
  {
    path: '/pay/broker/billDetail',
    name: 'billDetailBroker',
    meta: {
      title: '账单详情'
    },
    component: () => System.import('@/PagesAreaBroker/bill/billDetail')
  },
  // 自助缴费
  {
    path: '/pay/broker/selfService',
    name: 'selfServiceBroker',
    meta: {
      title: '添加生活费账单'
    },
    component: () => System.import("@/PagesAreaBroker/selfService/selfService")
  }
];



// WEBPACK FOOTER //
// ./src/router/broker.js